export const colors = {
  primaryDarkBlue: "#001433",
  primaryOrange: "#EC9A2F",
  primaryGreen: "#3E9166",
  primaryYellow: "#B49107",
  textBlue: "#3381FF",
};
